module.exports = __webpack_public_path__ + "img/kdj.2f498d8c.jpg";